import { render, staticRenderFns } from "./framework.vue?vue&type=template&id=e43650ca&scoped=true"
import script from "./framework.vue?vue&type=script&lang=js"
export * from "./framework.vue?vue&type=script&lang=js"
import style0 from "./framework.vue?vue&type=style&index=0&id=e43650ca&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e43650ca",
  null
  
)

export default component.exports